<div class="container-fluid"> 
    <app-loading-element  class="container-fluid componentBelow"></app-loading-element>
</div>
